import React, { type FunctionComponent } from 'react'
import { Breadcrumb, Breadcrumbs } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/partner-pick-devices/utils/domain/intl'
import { useStoreOpsNav } from 'domains/partner-pick-devices/utils/domain/useStoreOpsNav'

interface PartnerPickDevicesHeaderBreadcrumbsProps {}

export const PartnerPickDevicesHeaderBreadcrumbs: FunctionComponent<
  PartnerPickDevicesHeaderBreadcrumbsProps
> = () => {
  // Store Operations is the new flavor.
  // Delete this and go with the `true` case once `dashboard_store_ops_nav` flipper is fully enabled.
  const useStoreOps = useStoreOpsNav()

  return (
    <Breadcrumbs>
      <Breadcrumb>
        {useDomainMessage(
          useStoreOps ? 'partnerPickDevicesDomain.title.new' : 'partnerPickDevicesDomain.title'
        )}
      </Breadcrumb>
    </Breadcrumbs>
  )
}
